import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-10">
          <Lock className="w-5 h-5 text-white/40" />
          <h1 className="font-serif text-2xl font-light text-white tracking-tight">Admin</h1>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6" data-testid="admin-login-form">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
            data-testid="admin-login-email"
            className="w-full bg-transparent border-b border-white/15 focus:border-white py-3 text-base font-light text-white placeholder:text-white/25 outline-none transition-colors"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
            data-testid="admin-login-password"
            className="w-full bg-transparent border-b border-white/15 focus:border-white py-3 text-base font-light text-white placeholder:text-white/25 outline-none transition-colors"
          />
          {error && <p className="text-sm text-red-400/80" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full py-3 bg-white text-black text-sm uppercase tracking-[0.2em] font-medium hover:bg-white/90 transition-colors disabled:opacity-50"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <a href="/" data-testid="admin-back-link" className="block mt-8 text-xs text-white/30 hover:text-white/60 transition-colors text-center uppercase tracking-[0.2em]">
          Back to Portfolio
        </a>
      </div>
    </div>
  );
};

export default AdminLogin;
